import React, { useEffect, useState } from "react";
import { X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";

const sel = "bg-white border border-clay-300 px-2 py-1.5 text-sm outline-none focus:border-terracotta";

export function AgentMapModal({ onClose, onSaved }) {
  const [data, setData] = useState(null);
  const [map, setMap] = useState({});
  const [since, setSince] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/kimkim/agent-map").then(({ data: d }) => { setData(d); setMap(d.map || {}); setSince(d.since || ""); }).catch(() => toast.error("No se pudo cargar"));
  }, []);

  const save = async () => {
    setSaving(true);
    try { const { data: r } = await api.put("/kimkim/agent-map", { map, since }); toast.success(`Guardado · ${r.remapped} leads reasignados`); onSaved(); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "No se pudo guardar"); }
    finally { setSaving(false); }
  };

  const names = [...new Set([...(data?.specialists || []).map((s) => s.name), ...Object.keys(map)])].filter(Boolean);

  return (
    <div className="fixed inset-0 z-50 bg-clay-900/40 flex items-center justify-center p-4" onClick={onClose} data-testid="kimkim-agent-map-modal">
      <div className="bg-white border border-clay-300 w-full max-w-2xl p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-4">
          <div><div className="smallcaps">KimKim</div><h2 className="font-serif text-2xl mt-1">Especialistas → agentes</h2></div>
          <button onClick={onClose} className="p-1 text-clay-600 hover:text-clay-900" data-testid="kimkim-agent-map-close"><X size={18}/></button>
        </div>
        {!data ? <div className="text-sm text-clay-600"><Loader2 size={14} className="animate-spin inline mr-2"/>Cargando…</div> : (
          <>
            <p className="text-sm text-clay-700 mb-4">El nombre que KimKim muestra como especialista se empareja solo con los usuarios del cotizador. Corrige aquí los que no coincidan; se aplica a todos los leads sin ajuste manual.</p>
            <div className="border border-clay-200 divide-y divide-clay-200 max-h-80 overflow-y-auto">
              {names.length === 0 && <div className="p-4 text-sm text-clay-600">Aún no hay especialistas (haz la carga inicial).</div>}
              {names.map((n) => {
                const s = (data.specialists || []).find((x) => x.name === n);
                return (
                  <div key={n} className="flex items-center justify-between gap-3 px-3 py-2 text-sm">
                    <div><span className="font-medium">{n}</span>{s && <span className="text-clay-500 text-[11px] ml-2">{s.leads} leads</span>}</div>
                    <select className={sel} value={n in map ? (map[n] || "") : (s?.agent_email || "")} onChange={(e) => setMap({ ...map, [n]: e.target.value || null })} data-testid={`kimkim-map-${n}`}>
                      <option value="">Sin asignar</option>
                      {data.candidates.map((c) => <option key={c.email} value={c.email}>{c.name}</option>)}
                    </select>
                  </div>
                );
              })}
            </div>
            <label className="block mt-4 text-sm"><span className="text-[11px] text-clay-600 block mb-1">Importar leads con solicitud desde</span>
              <input type="date" className={sel} value={since} onChange={(e) => setSince(e.target.value)} data-testid="kimkim-since"/></label>
            <div className="flex justify-end gap-2 mt-5">
              <button onClick={onClose} className="px-4 py-2 border border-clay-300 text-[12px] uppercase tracking-wider">Cancelar</button>
              <button onClick={save} disabled={saving} className="px-4 py-2 bg-clay-900 text-white text-[12px] uppercase tracking-wider hover:bg-terracotta disabled:opacity-50" data-testid="kimkim-agent-map-save">{saving ? "Guardando…" : "Guardar"}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
